import axios from 'axios';
import { useAppStore } from '../store/appStore';

const API_URL = import.meta.env.VITE_API_URL;

const shouldSkipBranchFilter = (url) => {
  if (!url) return true;
  const normalizedUrl = url.startsWith('http') ? new URL(url).pathname : url;
  return (
    normalizedUrl.startsWith('/auth/') ||
    normalizedUrl.startsWith('/vendors/dashboard/') ||
    normalizedUrl.startsWith('/vendors/branches') ||
    normalizedUrl.startsWith('/system/system-printers') ||
    normalizedUrl.startsWith('/system/test-target-printer') ||
    normalizedUrl.startsWith('/system/health')
  );
};

console.log('[API] Base URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token and selected branch filter
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const branch = useAppStore.getState().branch;
    const isAllOutlets = !branch || branch?.isAllOutlets || branch?.id === 'all-outlets';
    if (config.method?.toLowerCase() === 'get' && !isAllOutlets && !shouldSkipBranchFilter(config.url)) {
      config.params = {
        ...(config.params || {}),
        branch_id: branch.id,
      };
    }

    console.log('[API] Request:', config.method?.toUpperCase(), config.url, config.params ?? 'no params');
    return config;
  },
  (error) => {
    console.error('[API] Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log('[API] Response:', response.status, response.config.url, response.data);
    return response;
  },
  (error) => {
    console.error('[API] Response Error:', error.response?.status, error.response?.data || error.message);
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
